import React from "react"
import EnumDisplayCell from "sheets/components/cells/EnumDisplayCell"

const e = DjangIO.app.userdata.types.InteractionType
export const InteractionCell = ({ children, ...props }) => (
    <EnumDisplayCell
        choices={e}
        item={e.by_value(children)}
        {...props}
    />
)
export default InteractionCell
